import { createTheme } from "@material-ui/core/styles";

// import Palette from '/client/configs/palette'
// import Colors from '/client/configs/colors'
import deepPurple from "@material-ui/core/colors/deepPurple";
import pink from "@material-ui/core/colors/pink";
import lightGreen from "@material-ui/core/colors/lightGreen";

export default createTheme({
    palette: {
        primary: {
            main: "#84349D",
        },
        secondary: {
            main: "#C25BBC",
        },
        type: "dark",
        background: {
            paper: "rgba(0, 0, 0, 0.1)",
            background: "rgba(0, 0, 0, 0.1)",
        },
    },
    typography: {
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
    },

    // appBar: {
    //   //height: 50,
    //   textColor: Colors.white,
    //   backgroundColor: Colors.app_primary1Color
    // },
    // toolbar: {
    //   //height: 50,
    //   backgroundColor: Colors.app_primary1Color,
    //   textColor: Colors.fullWhite,
    //   color: Colors.white,
    //   iconColor: Colors.app_icons,
    //   separatorColor: Colors.app_divider
    // },
    // tableRow: {
    //   hoverColor: Colors.app_hoverColor
    // },
    // overrides: {
    //   MuiTablePagination: {
    //     spacer: {
    //       flex: '0 1 auto'
    //     }
    //   }
    // }
});